/**
 * The answer to a part of the patient form's Validate button, shown under that part: what Medicare, DVA or
 * the fund said, and what it holds where that differs from what was typed. Nothing until the part is validated.
 */
app.component("patientCoverResult", {
	templateUrl: "app/src/js/components/patientCoverCheck/patientCoverResult.html",
	controller: "patientCoverResultController",
	bindings: {
		patient: "<",
		// The date of birth as the form holds it: { DD, MM, YYYY }.
		dateOfBirth: "<",
		// MEDICARE, DVA or POLICY.
		kind: "@",
		// The policy, for POLICY.
		policy: "<",
	},
});

app.controller("patientCoverResultController", [
	"PatientCoverCheckService",
	function (PatientCoverCheckService) {
		const $ctrl = this;

		$ctrl.state = function () {
			return PatientCoverCheckService.stateFor($ctrl.patient, $ctrl.kind, $ctrl.policy);
		};

		// Each digest: marks the answer stale once the details it was given for have changed, and takes off
		// the last_verified_at it stamped.
		$ctrl.$doCheck = function () {
			PatientCoverCheckService.reconcile($ctrl.patient, $ctrl.dateOfBirth, $ctrl.kind, $ctrl.policy);
		};
	},
]);
